import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbSegment } from 'projects/bis-shared/src/lib/breadcrumb/breadcrumb-segment';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';
import { DatatableColumn } from 'projects/bis-shared/src/lib/datatable/datatable-column';
import { DatatableSort } from 'projects/bis-shared/src/lib/datatable/datatable-sort';
import { Group } from 'projects/bis-shared/src/lib/shared-models/group';
import { DatatableStaticTemplateType } from 'projects/bis-shared/src/lib/datatable/datatable-static-template';
import { FieldLabelConstants } from 'projects/bis-shared/src/lib/utility/field-label-constants';
import { ExternalApiUrls } from 'projects/bis-shared/src/lib/utility/apiurls-external';

@Component({
  selector: 'app-my-groups',
  templateUrl: './my-groups.component.html',
  styleUrls: ['./my-groups.component.scss'],
})
export class MyGroupsComponent implements OnInit {
  @ViewChild('entityNameTemplate', { static: true }) entityNameTemplate: TemplateRef<any>;
  breadcrumbSegments: BreadcrumbSegment[];

  columns: DatatableColumn[];
  defaultSort: DatatableSort[];
  dataUrl: string;

  constructor(private router: Router, private externalApiUrls: ExternalApiUrls) {}

  ngOnInit() {
    this.breadcrumbSegments = [
      { routerLink: AppUrls.home(), text: 'Dashboard' },
      { routerLink: null, text: 'My Organizations' },
    ];

    this.columns = [
      { title: 'Type', property: 'entityTypeName', disableSorting: true },
      {
        title: 'Name',
        property: 'entityName',
        template: this.entityNameTemplate,
        disableSorting: true,
      },
      { title: 'Roles', property: 'entityGroupRoleName', disableSorting: true },
      {
        title: FieldLabelConstants.StartDate,
        property: 'effectiveStartDate',
        template: DatatableStaticTemplateType.UtcDateTemplate,
        disableSorting: true,
      },
    ];
    this.defaultSort = [
      {
        property: 'entityTypeName',
        sortAscending: true,
      },
      {
        property: 'entityName',
        sortAscending: true,
      },
    ];
    this.dataUrl = this.externalApiUrls.user.myGroups();
  }

  getDetailsLink(group: Group) {
    return AppUrls.detailsForSystemType(group.entityId, group.entityTypeCode);
  }
}
